import { render, staticRenderFns } from "./hoofdpagina.vue?vue&type=template&id=33805cf6&"
import script from "./hoofdpagina.vue?vue&type=script&lang=js&"
export * from "./hoofdpagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports